export default "__VITE_ASSET__8c9ba992__"